import { _ as __assign } from './_tslib-ff3a08af.js';
import { lighten } from '@material-ui/core';
import './globalButtonStyles-41c8af84.js';
import { s as styleConstants } from './constants-3b80be2a.js';
import 'react';

var customAsyncSelectStylesNew = function (hasError) {
    return {
        control: function (base, state) {
            return __assign(__assign({}, base), { boxShadow: 'none', border: hasError ? '2px solid red' : "2px solid ".concat(styleConstants.colors.primaryColor), '&:hover': {
                    border: hasError ? '2px solid red' : "2px solid ".concat(styleConstants.colors.primaryColor)
                }, '&:focus': { boxShadow: 'none' }, minWidth: '225px', color: 'red', fontWeight: 700 });
        }
    };
};
var customAsyncSelectStyles = {
    control: function (base, state) {
        return __assign(__assign({}, base), { boxShadow: 'none', border: '2px solid #DDDDDD', '&:hover': {
                border: '2px solid #DDDDDD'
            }, '&:focus': { boxShadow: 'none' }, minWidth: '225px', color: 'red', fontWeight: 700 });
    },
    valueContainer: function (base, state) {
        return __assign(__assign({}, base), { paddingTop: '0px' });
    },
    input: function (base, state) {
        return __assign(__assign({}, base), { fontWeight: 700, margin: '0px', position: 'relative', width: '100%', '& input': {
                fontWeight: 700,
                fontSize: '16px',
                fontFamily: 'Ubuntu Sans, sans-serif',
                lineHeight: '20px',
                letterSpacing: '0.89px',
                height: '100% !important',
                width: '100% !important',
                position: 'absolute',
                top: 0
            } });
    },
    clearIndicator: function (base, state) {
        return __assign(__assign({}, base), { padding: 0 });
    },
    multiValue: function (base, state) {
        return __assign(__assign({}, base), { backgroundColor: styleConstants.colors.primaryColor, borderRadius: '5px' });
    },
    multiValueLabel: function (base, state) {
        return __assign(__assign({}, base), { color: styleConstants.colors.white });
    },
    multiValueRemove: function (base, state) {
        return __assign(__assign({}, base), { color: styleConstants.colors.white, ':hover': {
                backgroundColor: lighten(styleConstants.colors.primaryColor, 0.3),
                color: 'white',
                cursor: 'pointer',
                borderRadius: '5px'
            } });
    }
};

export { customAsyncSelectStyles as a, customAsyncSelectStylesNew as c };
